module.exports = __webpack_public_path__ + "static/media/buenos-aires-al-aire-libre.5e7aa958.md";